import { useEffect, useState, type RefObject } from 'react';

/** Видимость элемента через IntersectionObserver; rootMargin задаёт упреждение (например 400px для подгрузки). */
export function useInView(
  ref: RefObject<Element | null>,
  rootMargin = '0px',
  enabled = true,
): boolean {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) setInView(entry.isIntersecting);
      },
      { rootMargin },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, rootMargin, enabled]);

  return inView;
}
